import ko from 'knockout';

declare global {

    export interface String {
        startsWith(str: string): boolean;
        endsWith(str: string): boolean;
        indexOfAny(anyOf: Array<string>, startIndex?: number, count?: number);
        format(...replacements: string[]): string;
        formatAsHtmlStrong(...replacements: string[]): string;
        cleanRestirctedMarkdown(): string;
        encodedHtmlFromRestrictedMarkdown(skipLineBreak?:boolean):string;
        doNothingJustReturnsOriginal(): string;
        truncate(length: number): string;
        toMonogram(): string;
        encodeHtml(): string;
        decodeHtml(): string;
        doubleEscapeSafeHtmlEncode(): string;
        contains(keyword: string): boolean;
    }

    export interface Number {
        toPrettyFixedNumber(precision: number) : number;
    }


    // Linq extensions

    // http://www.codeproject.com/Tips/747405/LINQ-TypeScript

    export interface Array<T> {
        move(from: number, to: number);
        remove(from: number, to: number);
        select<U>(cvt: (item: T) => U): Array<U>;
        where(predicate: (item: T) => boolean): Array<T>;
        firstOrDefault(predicate: (item: T) => boolean): T;
        any(predicate: (item: T) => boolean): boolean;
        forEachItem(action: (item: T) => void);
        orderBy<U>(cvt: (item: T) => U): Array<T>;
        orderByDescending<U>(cvt: (item: T) => U): Array<T>;
        groupBy<U>(cvt: (item: T) => U): Array<Grouping<T, U>>;
        distinct<T>(): Array<T>;
        take(limit: number): Array<T>;
        skip(offset: number): Array<T>;
        removeItem(action: (item: T) => void);
    }

    export interface KnockoutObservableArrayFunctions<T> {
        where(predicate: (item: T) => boolean): Array<T>;
        firstOrDefault(predicate: (item: T) => boolean): T;
        any(predicate: (item: T) => boolean): boolean;
        forEach(action: (item: T) => void);
        removeItem(action: (item: T) => void);
    }

}

// Implementation

/**
 * Move method for array
**/
Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};


/**
 * Remove element by value
**/
Array.prototype.remove = function(value) {
    if (this.indexOf(value) !== -1) {
        this.splice(this.indexOf(value), 1);
        return true;
    } else {
        return false;
    };
};

/**
*   String:startWith
**/
if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) == str;
    };
}


/**
*   String:endsWith
**/
if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}


/**
*   String:truncate
**/
if (typeof String.prototype.truncate != 'function') {
    String.prototype.truncate = function(length) {

        var text = this;
        var ellipsis = '...';

        // Return if the text is already lower than the cutoff
        if (text.length < length) return text;

        // Otherwise, check if the last character is a space.
        // If not, keep counting down from the last character
        // until we find a character that is a space
        for (var i = length - 1; text.charAt(i) != ' ' && i > 0; i--) {
            length--;
        }

        // The for() loop ends when it finds a space, and the length var
        // has been updated so it doesn't cut in the middle of a word.
        return text.substr(0, length) + ellipsis;
    };
}


/**
*   String:format /
**/

// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? args[number]
              : match
            ;
        });
    };
}

if (!String.prototype.formatAsHtmlStrong) {
    String.prototype.formatAsHtmlStrong = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? '<strong>' + args[number] + '</strong>'
              : match
            ;
        });
    };
}


if (!String.prototype.toMonogram) {
    String.prototype.toMonogram = function () {
        var monogram = "";
        var user = this;
        var parts = user.split(" ");
        if (parts.length === 1) {
            var mo = parts[0].trim();
            if (mo.length > 0) {
                mo = mo.substring(0, 1);
            }
            monogram = mo;
        } else if (parts.length > 1) {
            var f = parts[0].trim();
            if (f.length > 0) {
                f = f.substring(0, 1);
            }
            var s = parts[1].trim();
            if (s.length > 0) {
                s = s.substring(0, 1);
            }
            monogram = f + s;
        }
        if (monogram === "") {
            monogram = "?";
        }
        return monogram;
    };
}

// Restircted markdown - az általunk title-kben használt markdown
if (!String.prototype.cleanRestirctedMarkdown) {
    String.prototype.cleanRestirctedMarkdown = function () {
        // Em, Strong
        var resultString = this
            // Named link
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1')
            // em, strong
            .replace(/([*_]+)(\S.*?)\1/g, function (match, wrapper, content) {
                switch (wrapper.length) {
                    case 1:
                        return '' + content + '';
                    case 2:
                        return '' + content + '';
                    case 3:
                        return '' + content + '';
                    default:
                        return wrapper + content * wrapper;
                }
            });
        resultString = resultString.replace(/[\r\n]+/g, ' '); // Multiple newline with one
        return resultString;
    };
}


// Restircted markdown - az általunk title-kben használt markdown
if (!String.prototype.encodedHtmlFromRestrictedMarkdown) {
    String.prototype.encodedHtmlFromRestrictedMarkdown = function (skipLineBreak) {
        var str = this;
        str = str.toString(); // Ha number, akkor nincs hozzá replace függvény...
        var resultString = str.encodeHtml();
        // Em, Strong
        resultString = resultString
            // Named link
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
            // em, strong
            .replace(/([*_]+)(\S.*?)\1/g, function (match, wrapper, content) {
                switch (wrapper.length) {
                    case 1:
                        return '<em>' + content + '</em>';
                    case 2:
                        return '<strong>' + content + '</strong>';
                    case 3:
                        return '<em><strong>' + content + '</strong></em>';
                    default:
                        return wrapper + content * wrapper;
                }
            });
        if (skipLineBreak) {
            resultString = resultString.replace(/[\r\n]+/g, ' '); // Multiple newline with one
        } else {
            resultString = resultString.replace(/[\r\n]+/g, '<br/>'); // Multiple newline with one
        }
        return resultString;
    };
}



if (!String.prototype.doNothingJustReturnsOriginal) {
    String.prototype.doNothingJustReturnsOriginal = function () {
        var str = this;
        return str;
    };
}


if (!String.prototype.encodeHtml) {
    String.prototype.encodeHtml = function () {
        var map = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            "\"": "&quot;",
            "'": "&#39;" // ' -> &apos; for XML only
        };
        return this.replace(/[&<>"']/g, function (m) { return map[m]; });
    };
}


// http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
if (!String.prototype.doubleEscapeSafeHtmlEncode) {
    String.prototype.doubleEscapeSafeHtmlEncode = function () {
        return this.replace(
            /[&<>'"]/g,
            function(c, offset, str) {
                if (c === "&") {
                    var substr = str.substring(offset, offset + 6);
                    if (/&(amp|lt|gt|apos|quot);/.test(substr)) {
                        // already escaped, do not re-escape
                        return c;
                    }
                }
                return "&" + {
                    "&": "amp",
                    "<": "lt",
                    ">": "gt",
                    "'": "apos",
                    '"': "quot"
                }[c] + ";";
            }
        );
    };
}


if (!String.prototype.decodeHtml) {
    String.prototype.decodeHtml = function () {
        var map = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": "\"",
            "&#39;": "'"
        };
        return this.replace(/(&amp;|&lt;|&gt;|&quot;|&#39;)/g, function(m) { return map[m]; });
    };
}




//String.prototype.format = function (args) {
//    if (!(args instanceof Array)) {
//        args = [args];
//    }
//    var str = this;
//    return str.replace(String.prototype.format.regex, function (item) {
//        var intVal = parseInt(item.substring(1, item.length - 1));
//        var replace;
//        if (intVal >= 0) {
//            replace = args[intVal];
//        } else if (intVal === -1) {
//            replace = "{";
//        } else if (intVal === -2) {
//            replace = "}";
//        } else {
//            replace = "";
//        }
//        return replace;
//    });
//};
//String.prototype.format.regex = new RegExp("{-?[0-9]+}", "g");


/**
 * Reports the index of the first occurrence in this instance of any character in a specified array of Unicode characters.
 * <p><b>Example :</b></p>
 * <pre class="prettyprint">
 * result = core.strings.indexOfAny("hello world", [2, "hello", 5]) ;
 * trace( result ) ; // 0
 *
 * result = core.strings.indexOfAny("Five = 5", [2, "hello", 5]) ;
 * trace( result ) ; // 2
 *
 * result = core.strings.indexOfAny("actionscript is good", [2, "hello", 5]) ;
 * trace( result ) ; // -1
 * </pre>
 * @return the index of the first occurrence in this instance of any character in a specified array of Unicode characters.
 */
String.prototype.indexOfAny = function (anyOf /*Array*/, startIndex /*uint*/, count /*int*/) /*int*/ {


    startIndex = isNaN(startIndex) ? 0 : startIndex;
    if (startIndex < 0) {
        startIndex = 0;
    }

    if (this == null || this == "") return -1;
    count = isNaN(count) ? -1 : ((count >= 0) ? count : -1);
    var l = this.length;
    var endIndex /*int*/;
    if ((count < 0) || (count > l - startIndex)) {
        endIndex = l;
    }
    else {
        endIndex = startIndex + count;
    }

    if (anyOf == null || anyOf == undefined) return -1;

    for (var i = startIndex; i <= endIndex ; i++) {
        var curtxt = this.substring(startIndex, i);

        var allindex = [];
        for (var j = 0; j < anyOf.length; j++) {
            var any = anyOf[j];
            var index = curtxt.indexOf('' + any);
            if (index > -1) {
                return index + startIndex;
            }
        }
    }

    return -1;

};



/*
 * Nem maradnak nullák a végén...
 */
if (typeof Number.prototype.toPrettyFixedNumber != 'function') {
    Number.prototype.toPrettyFixedNumber = function (precision) {

        var value = this;
        precision = precision || 0;

        var rounded = (!isNaN(precision) && parseInt(precision.toString(), 10) > 0)
            ? parseFloat(value).toFixed(parseInt(precision.toString(), 10))
            : value;

        var trimmed = parseFloat(rounded);

        return trimmed;
    };
}


// Linq extensions
ko.observableArray.fn.where = function <T>(predicate: (item: T) => boolean): Array<T> {
    var result = [];
    for (var i = 0; i < this().length; i++) {
        var item = this()[i];
        if (predicate(item))
            result.push(item);
    }
    return result;
};
ko.observableArray.fn.firstOrDefault = function <T>(predicate: (item: T) => boolean): T {
    for (var i = 0; i < this().length; i++) {
        var item = this()[i];
        if (predicate(item))
            return item;
    }
    return null;
};
ko.observableArray.fn.any = function <T>(predicate: (item: T) => boolean): boolean {
    for (var i = 0; i < this().length; i++) {
        var item = this()[i];
        if (predicate(item))
            return true;
    }
    return false;
};
ko.observableArray.fn.forEach = function <T>(action: (item: T) => void) {
    for (var i = 0; i < this().length; i++) {
        var item = this()[i];
        var x: any = action(item);
        if (x == false)
            return;
    }
};
ko.observableArray.fn.removeItem = function <T>(action: (item: T) => void) {
    this.remove(this.firstOrDefault(action));
};

/** return a subset of an array matching a predicate */
Array.prototype.where = function <T>(predicate: (item: T) => boolean): Array<T> {
    var result = [];
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        if (predicate(item))
            result.push(item);
    }
    return result;
};

/** return the first element of an array matching a predicate or null */
Array.prototype.firstOrDefault = function <T>(predicate: (item: T) => boolean): T {
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        if (predicate(item))
            return item;
    }
    return null;
};


/** return true if any element of the array matching the predicate */
Array.prototype.any = function <T>(predicate: (item: T) => boolean): boolean {
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        if (predicate(item))
            return true;
    }
    return false;
};


/** convert an array to another one */
Array.prototype.select = function <T, U>(cvt: (item: T) => U): Array<U> {
    var result = [];
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        var ci = cvt(item);
        result.push(ci);
    }
    return result;
};

Array.prototype.forEachItem = function <T>(action: (item: T) => void) {
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        var x: any = action(item);
        if (x == false)
            return;
    }
};

Array.prototype.orderBy = function <T, U>(cvt: (item: T) => U): Array<T> {
    var compare = function (a, b) {
        if (typeof cvt(a) == "string") {
            return (<string><any>cvt(a)).localeCompare(<string><any>cvt(b));
        } else {
            if (cvt(a) > cvt(b)) {
                return 1;
            }
            if (cvt(a) < cvt(b)) {
                return -1;
            }
            return 0;
        }

    }
    return this.sort(compare);
}

Array.prototype.orderByDescending = function <T, U>(cvt: (item: T) => U): Array<T> {
    var compare = function (a, b) {
        if (cvt(a) > cvt(b)) {
            return -1;
        }
        if (cvt(a) < cvt(b)) {
            return 1;
        }
        return 0;
    }
    return this.sort(compare);
}

Array.prototype.groupBy = function<T, U>(cvt: (item: T) => U): Array<Grouping<T, U>> {
    var groups = this.select(x => cvt(x)).distinct();
    return groups.select(x => new Grouping(x, this.where(y => cvt(y) == x)));
}

Array.prototype.distinct = function<T>(): Array<T> {
    var unique = function(value, index, self) {
        return self.indexOf(value) === index;
    }
    return this.filter(unique);
}

Array.prototype.take = function<T>(limit: number): Array<T> {
    return this.slice(0, limit);
}

Array.prototype.skip = function <T>(offset: number): Array<T> {
    if (offset >= this.length) {
        return [];
    }
    return this.slice(offset, this.length - 1);
}

Array.prototype.removeItem = function <T>(action: (item: T) => void) {
    this.remove(this.firstOrDefault(action));
};

String.prototype.contains = function (keyword: string): boolean {
    return this.toLocaleLowerCase().indexOf(keyword.toLocaleLowerCase()) > -1;
};


//ko.observable.fn.contains = function (keyword: string): boolean {
//    var ths = this();
//    if (ths !== null && ths !== undefined && ths instanceof String) {
//        return ths.toLocaleLowerCase().indexOf(keyword.toLocaleLowerCase()) > -1;
//    }
//    return false;
//};


class Grouping<T, U> {
    public group: U;
    public items: T[];

    constructor(group: U, items: T[]) {
        this.group = group;
        this.items = items;
    }
}
